import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import {
  fetchDashboardStatements,
  resetDashboardStatements,
  sendStatementemail
} from 'alelo-logic/actions'
import StatementsHeader from '../../elements/StatementsHeader'
import AddItem from '../../modules/AddItem'
import StatementsList from '../../modules/StatementsList'
import StatementsFilter from '../../modules/StatementsFilter'
import { setLoading } from '../../modules/PageLoader/actions'
import ShowResults from './ShowResults/ShowResults'

import EmailStatementModal from '../../modules/EmailStatementModal'

import Content from '../../../styles/objects/Content'
import { Title, Paragraph, ShowResultsContainer, ShowResultsInner } from './styles'
import { helmetTitle, topbar } from './data.json'

import statementFactory from './factory'

import { showModal } from '../../modules/ModalRoot/actions'
import imageContestacao from '../../../static/contestacao.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

class DashboardStatement extends Component {
  state = {
    showFilter: false,
    loading: false,
    showModalEmail: false,
    formato: null,
    emailSendStatement: null,
    showResults: false,
    hasValePedagio: false
  }

  componentWillMount() {
    this.props.setLoading(true)

    if ((this.props.account || {}).pc) {
      this.props.history.push(`/minha-veloe/${this.props.match.params.id}/extrato-parceiro`)
      return
    }
    this.props.fetchStatements(this.props.match.params.id)
  }

  componentWillUnmount() {
    this.props.resetStatements()
  }

  selectedFilters = {}

  resetList() {
    this.props.resetStatements()
    this.doStatementFetch()
  }

  loadStatements = (nextPage = 0) => {
    const params = this.props.match.params || {}
    this.props.fetchStatements(params.id, nextPage, this.selectedFilters)
  }

  doStatementFetch = (nextPage, filter) => {
    const params = this.props.match.params || {}
    this.props.fetchStatements(params.id, nextPage, filter).then(() => {
      this.setState({ loading: false })
    })
    this.setState({ loading: true })
  }

  openFilter = () => {
    this.setState({ showFilter: true })
  }

  applyFilter = filter => {
    this.selectedFilters = filter
    this.props.resetStatements()
    this.doStatementFetch(null, this.selectedFilters)
    this.setState({ showFilter: false, showResults: true })
  }

  unsetResults = () => this.setState({ showResults: false })

  closeFilter = () => {
    this.setState({ showFilter: false })
  }

  handleModal = async () => {
    const { emailSendStatement, formato } = this.state
    const params = this.props.match.params || {}

    await this.props.sendStatementEmail(
      params.id,
      emailSendStatement,
      this.selectedFilters,
      formato
    )

    this.setState({ showModalEmail: !this.state.showModalEmail, formato: null })
  }

  handleChangeEmail = value => {
    const result = Object.keys(value).map(function(key) {
      return [value[key]]
    })

    const valueEmail = result.splice(0, result.length - 1).join('')
    this.setState({ emailSendStatement: valueEmail })
  }

  modalEmail = (state, formato) => this.setState({ showModalEmail: state, formato })

  setHasValePedagio = boolean => this.setState({ hasValePedagio: boolean })

  render() {
    const { statements, accountPlans } = this.props
    const { showModalEmail, showFilter, showResults, hasValePedagio } = this.state
    return (
      <div>
        <Helmet title={helmetTitle} />
        <StatementsFilter
          onFilter={values => this.applyFilter(values)}
          statements={statements}
          accountPlans={accountPlans}
          accountId={this.props.match.params.id}
          showFilter={showFilter}
          unsetResults={this.unsetResults}
          hasValePedagio={hasValePedagio}
          setHasValePedagio={this.setHasValePedagio}
        />
        <div>
          {showResults && (
            <ShowResultsContainer>
              <ShowResultsInner>
                <ShowResults
                  selectedFilters={this.selectedFilters}
                  hasValePedagio={hasValePedagio}
                  showQuantity={false}
                />
              </ShowResultsInner>
            </ShowResultsContainer>
          )}
          <StatementsHeader
            statements={statements}
            currency={topbar.currency}
            match={this.props.match}
            downloadEnabled={!!statements.data.length}
            openModal={this.modalEmail}
          />
          {statements.data.length === 0 ? (
            <Content>
              <Title>Ops!</Title>
              <Paragraph>Nenhuma transação encontrada para o filtro selecionado.</Paragraph>
            </Content>
          ) : (
            <div>
              <AddItem
                data={statementFactory.toForm(statements.data)}
                next={statements.next}
                fetchHandler={this.loadStatements}
                hasNext={statements.hasNext}
              >
                <StatementsList />
              </AddItem>
            </div>
          )}
        </div>
        {showModalEmail && (
          <EmailStatementModal
            handleClick={this.handleModal}
            openModal={this.modalEmail}
            handleChangeEmail={this.handleChangeEmail}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  statements: reducer.dashboardStatements,
  accountPlans: reducer.accountPlans,
  account: reducer.account
})

const mapDispatchToProps = dispatch => ({
  fetchStatements: (planId, nextPage, filter) =>
    dispatch(fetchDashboardStatements(planId, nextPage, filter)).then(resp => {
      if (resp && resp.status === 204) {
        dispatch(setLoading(false))
        dispatch(resetDashboardStatements())
      }
      dispatch(setLoading(false))
    }),
  sendStatementEmail: (planId, email, filter, formato) =>
    dispatch(sendStatementemail(planId, email, filter, formato)).then(() => {
      dispatch(
        showModal(CONFIRM_UPDATE, {
          modalTitle: 'Extrato em processamento.',
          modalDescription: `O ${formato} do seu extrato está em processamento, assim que finalizado você recebera um email com o link para baixa-lo.`,
          image: imageContestacao
        })
      )
      dispatch(setLoading(false))
    }),
  resetStatements: () => {
    dispatch(setLoading(true))
    dispatch(resetDashboardStatements())
  },
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardStatement)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/index.js